/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/no-unused-prop-types */
/*********************** Preact *******************************/
import { Component } from "preact";
import { string } from "prop-types";
import { connect } from "preact-redux";
/********************** Custom components *********************/
import SankeyChart from "../../sankeyChart";
import PreLoader from "../../preLoader";
import NoDataTemplate from "../../no-data-template";
/************************* Style Files ************************/
import style from "./style";
/**************************************************************/
import YearSelector from "../../yearSelector";

class Sankey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstChecked: true, // Financial Flow type selector
      year: this.props.year, // Financial Flow year selector
      modalState: false, // Financial Flow year selector drop down state
    };
  }

  static propTypes = {
    // Prop Types
    firstChecked: string, // Financial Flow type selector - Default type - string
    year: string, // Financial Flow year selector - Default type - string
    modalState: string, // Financial Flow year selector drop down state - Default type - string
  };

  static defaultProps = {
    // Default Props
    firstChecked: true, // Financial Flow type selector - Default selection - Budget
    year: "", // Financial Flow year selector - Default selection - Current Year
    modalState: false, // Financial Flow year selector drop down state - Default selection - Dropdown close
  };
  componentWillMount() {
    if (this.props.embed) {
      const { financialFlowType, financialFlowYear } = this.props;
      financialFlowType === "budget"
        ? this.props.fetchBudgetFinancialFlow(financialFlowYear)
        : this.props.fetchExpenseFinancialFlow(financialFlowYear);
    } else {
      if (this.state.year) {
        // Fetch Budget Financial Flow if year available
        this.props.fetchBudgetFinancialFlow(this.state.year);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    // Fetch Budget Financial Flow only if year is changed
    if (this.props.year != nextProps.year) {
      this.setState(
        {
          year: nextProps.year,
        },
        () => {
          this.state.firstChecked
            ? this.props.fetchBudgetFinancialFlow(nextProps.year) // Financial Flow type selector = budget
            : this.props.fetchExpenseFinancialFlow(nextProps.year); // Financial Flow type selector = expense
        }
      );
    }
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.handleClickOutside);
    window.addEventListener("touchstart", this.handleClickOutside);
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("touchstart", this.handleClickOutside);
  }

  onBudgetChanged = () => {
    // Financial Flow type selector = budget
    this.setState({ firstChecked: true }, () => {
      this.props.getBugetType &&
        this.props.getBugetType(this.state.firstChecked);
    });

    if (this.state.year) {
      this.props.fetchBudgetFinancialFlow(this.state.year);
    }
  };
  onExpenseChanged = () => {
    // Financial Flow type selector = expense
    this.setState({ firstChecked: false }, () => {
      this.props.getBugetType &&
        this.props.getBugetType(this.state.firstChecked);
    });
    if (this.state.year) {
      this.props.fetchExpenseFinancialFlow(this.state.year);
    }
  };

  switchModalState = () => {
    // Drop Down List state Management
    this.setState((prevState) => ({
      modalState: !prevState.modalState, // Drop down hide/ show
    }));
  };
  handleYearSelection = (year) => {
    this.props.setCurrentYear(year)
    // Financial Year Selection
    this.setState({ year: year, modalState: false }, () => {
      this.state.firstChecked
        ? this.props.fetchBudgetFinancialFlow(this.state.year) // Financial Flow type selector = budget
        : this.props.fetchExpenseFinancialFlow(this.state.year); // Financial Flow type selector = expense
    });
  };
  render(props, { firstChecked, year, modalState }) {
    return (
      <div>
        {/* Financial Flow Toolbar start */}
        <div class={style.filtersWrapper}>
          {/* Financial Year Selection  start */}
          {!this.props.embed || this.props.embed === undefined ? (
            <div className={style.tabSelectionWrapper}>
              <span
                className={
                  firstChecked
                    ? style.tabSectionSelectedItem
                    : style.tabSectionItem
                }
                onClick={() => this.onBudgetChanged()}
              >
                Budget
              </span>
              <span
                className={
                  firstChecked
                    ? style.tabSectionItem
                    : style.tabSectionSelectedItem
                }
                onclick={() => this.onExpenseChanged()}
              >
                Expenses
              </span>
            </div>
          ) : null}

          {/* Financial Year Selection  end */}
          {/* Year Chooser Start */}

          {!this.props.embed || this.props.embed === undefined ? (
            <div class={style.yearSelectorWrapper}>
              <YearSelector
                selectedYear={year}
                onSelectYear={(selectedYear) => {
                  this.props.getSankeyYear &&
                    this.props.getSankeyYear(selectedYear);
                  this.handleYearSelection(selectedYear);
                }}
              />
            </div>
          ) : null}

          {/* Year Chooser End */}
        </div>
        {/* Financial Flow Toolbar end */}
        {/* Financial Flow Diagram start */}
        {props.loading ? (
          <div class={style.loaderWrapper}>
            <PreLoader />
          </div>
        ) : this.props.items.nodes && this.props.items.links ? (
          <SankeyChart
            firstChecked={firstChecked}
            sankeyYear={year}
            data={this.props.items}
            currentYearSelected={this.props.currentYearSelected}
          />
        ) : (
          <NoDataTemplate />
        )}
        {/* Financial Flow Diagram end */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const yearList = state.yearList,
    timeLine = state.projectTimeline.year;
  return {
    yearList,
    timeLine,
  };
};

export default connect(mapStateToProps)(Sankey);



// WEBPACK FOOTER //
// ./components/sankey/component/index.js